module.exports = __webpack_public_path__ + "static/proxy_2-fc87719cecf293e5fcf0d5ba94b434b4.png";